import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import PageShell from '../components/PageShell';
import TreasureChest from '../components/TreasureChest';

export default function TreasureChestPage() {
  const navigate = useNavigate();

  return (
    <PageShell title="Treasure Chest">
      <div className="p-5" data-testid="treasure-chest-page">
        <button
          data-testid="treasure-back-to-profile"
          onClick={() => navigate('/profile')}
          className="flex items-center gap-2 text-xs text-muted-foreground hover:text-foreground transition-colors mb-4"
        >
          <ArrowLeft className="w-3.5 h-3.5" />
          Back to Profile
        </button>
        <TreasureChest />
      </div>
    </PageShell>
  );
}
